import {
  Component, OnInit, ViewEncapsulation,
  Input, ViewChild, ElementRef
} from '@angular/core';

import { loaderColors } from '@ux/entities/loader-colors';

declare const pdfjsLib;

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})
export class PdfViewerComponent implements OnInit {

  @ViewChild('pdfViewer') public pdfViewer: ElementRef;
  @ViewChild('currentPage') public currentPage: ElementRef;
  @ViewChild('totalPages') public totalPages: ElementRef;
  @ViewChild('loading') public loading: ElementRef;
  @ViewChild('pdfViewViewer') public pdfViewViewer: ElementRef;

  @Input() srcPdf: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public pdfInstance: any = null;
  public currentPageIndex: number = 0;
  public totalPagesCount: number = 0;
  public classColor: string = loaderColors.GRAY;

  constructor() { }

  ngOnInit(): void {
    this.loadPDF();
  }

  private loadPDF(): void {
    if (typeof window !== 'undefined' && this.srcPdf && pdfjsLib) {
      const initPDF = pdfjsLib.getDocument(this.srcPdf).then((pdf) => {
        this.loading.nativeElement.style.display = 'none';
        this.pdfViewViewer.nativeElement.style.display = 'block';
        this.pdfInstance = pdf;
        this.totalPages.nativeElement.innerHTML = pdf.numPages;
        this.totalPagesCount = pdf.numPages;
        this.currentPageIndex = this.currentPageIndex + 1;
        this.renderPageByCurrentPage();
      });
      window['initPDFViewer'] = initPDF;
    }
  }

  public render(): void {
    this.renderPageByCurrentPage();
  }

  public renderPageByCurrentPage(): void {
    this.currentPage.nativeElement.innerHTML = this.currentPageIndex;
    this.pdfInstance.getPage(this.currentPageIndex).then((page) => {
      this.pdfViewer.nativeElement.innerHTML = '<div><canvas></canvas></div>';
      this.renderPage(page);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public renderPage(page: any): void {
    let pdfViewport = page.getViewport(1);
    const container = this.pdfViewer.nativeElement.children[0];
    pdfViewport = page.getViewport(container.offsetWidth / pdfViewport.width);
    const canvas = container.children[0];
    const context = canvas.getContext('2d');
    canvas.height = pdfViewport.height;
    canvas.width = pdfViewport.width;
    page.render({
      canvasContext: context,
      viewport: pdfViewport,
    });
  }

  public viewNextPage(): void {
    if ((this.currentPageIndex + 1) <= this.totalPagesCount) {
      this.currentPageIndex = this.currentPageIndex + 1;
      this.renderPageByCurrentPage();
    }
  }

  public viewPreviousPage(): void {
    if (this.currentPageIndex > 1) {
      this.currentPageIndex = this.currentPageIndex - 1;
      this.renderPageByCurrentPage();
    }

  }
}
